module.exports = __webpack_public_path__ + "img/Ask-for-Demo.569468e3.svg";